import { useEffect, useState } from "react";
import { UserCheck, ArrowRight } from "lucide-react";
import bg1 from "../assets/bg1.png";
import bg2 from "../assets/bg2.png";

const images = [bg1, bg2];

export default function Hero() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="h-[60vh] bg-cover bg-center flex items-center"
      style={{ backgroundImage: `url(${images[current]})` }}
    >
      {/* Light overlay */}
      <div className="bg-white/70 w-full h-full flex items-center px-10">
        <div className="max-w-xl">
          {/* HERO TEXT */}
          <h1 className="text-4xl font-bold text-gray-800 leading-snug">
            Fast, Reliable <br />
            <span className="text-orange-500">Delivery</span>
            <span className="ml-2">at your </span>
            <br />
            Fingertips
          </h1>

          {/* DESCRIPTION */}
          <p className="mt-4 text-black-600">
            Jopo Delivery Connects you with trusted riders for <br />
            <span>same-day delivery, real-time tracking and secure payments.</span>
            
          </p>

          {/* BUTTONS */}
          <div className="flex items-center gap-4 mt-6">
            {/* REQUEST DELIVERY BUTTON */}
            <button className="flex items-center gap-2 h-12 px-6 rounded-lg bg-orange-500 text-white font-medium shadow hover:bg-orange-600 transition">
              <span>Request Delivery</span>

              <ArrowRight size={16} className="mt-[5px]" />
            </button>

            {/* BECOME RIDER */}
            <button className="flex items-center gap-2 h-12 px-6 rounded-lg border border-green-700 bg-white hover:shadow transition">
              <div className="bg-green-700 text-white p-2 rounded-full flex items-center justify-center">
                <UserCheck size={16} />
              </div>

              <span className="text-green-700 font-medium">Become a Rider</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
